/**
 * Product Sticky Cart
 * SP専用の追従カートとバリアントドロワー
 */

class ProductStickyCart {
  constructor() {
    this.stickyCart = document.querySelector('[data-sticky-cart]');
    this.drawer = document.querySelector('[data-product-drawer]');
    this.originalCartButton = document.querySelector('.product-form__submit[type="submit"]');
    this.productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    
    if (!this.stickyCart || !this.drawer || !this.originalCartButton || !this.productForm) return;
    
    this.init();
  }

  init() {
    // スクロール監視
    this.observeScroll();
    
    // 追従カートのボタンクリックでドロワーを開く
    const stickyCartBtn = this.stickyCart.querySelector('[data-sticky-cart-button]');
    if (stickyCartBtn) {
      stickyCartBtn.addEventListener('click', () => this.openDrawer());
    }
    
    // ドロワーを閉じる
    const closeBtn = this.drawer.querySelector('[data-drawer-close]');
    const overlay = this.drawer.querySelector('[data-drawer-overlay]');
    
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeDrawer());
    }
    
    if (overlay) {
      overlay.addEventListener('click', () => this.closeDrawer());
    }
    
    // ドロワー内のカートボタン
    const drawerCartBtn = this.drawer.querySelector('[data-drawer-add-to-cart]');
    if (drawerCartBtn) {
      drawerCartBtn.addEventListener('click', () => this.addToCart());
    }
    
    // バリアント変更時に追従カートのボタン状態を同期
    this.observeVariantChange();
    
    // 初期表示時も同期
    this.syncStickyCartButton();
    
    // ドロワー内のバリアント初期選択
    this.selectInitialVariantInDrawer();
  }

  observeVariantChange() {
    // バリアント変更を監視して追従カートのボタンを同期
    if (typeof subscribe !== 'function') {
      // PUB_SUBが利用できない場合は、MutationObserverで監視
      this.observeButtonChanges();
      return;
    }
    
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      this.syncStickyCartButton();
    });
  }
  
  observeButtonChanges() {
    // 元のボタンの変更を監視
    const observer = new MutationObserver(() => {
      this.syncStickyCartButton();
    });
    
    if (this.originalCartButton) {
      observer.observe(this.originalCartButton, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }
  
  syncStickyCartButton() {
    const stickyBtn = this.stickyCart.querySelector('[data-sticky-cart-button]');
    const drawerBtn = this.drawer.querySelector('[data-drawer-add-to-cart]');
    
    if (!this.originalCartButton) return;
    
    // disabled状態を同期
    const isDisabled = this.originalCartButton.hasAttribute('disabled');
    
    if (stickyBtn) {
      if (isDisabled) {
        stickyBtn.setAttribute('disabled', '');
      } else {
        stickyBtn.removeAttribute('disabled');
      }
    }
    
    if (drawerBtn) {
      if (isDisabled) {
        drawerBtn.setAttribute('disabled', '');
      } else {
        drawerBtn.removeAttribute('disabled');
      }
    }
    
    // テキストとアイコンを同期
    const originalSpan = this.originalCartButton.querySelector('span');
    
    if (originalSpan) {
      // loading spinnerを除外したHTMLを取得
      const content = originalSpan.innerHTML.replace(/<span class="loading__spinner[^>]*>.*?<\/span>/s, '');
      
      if (stickyBtn) {
        const stickySpan = stickyBtn.querySelector('span');
        if (stickySpan) {
          stickySpan.innerHTML = content;
        }
      }
      
      if (drawerBtn) {
        const drawerSpan = drawerBtn.querySelector('span');
        if (drawerSpan) {
          drawerSpan.innerHTML = content;
        }
      }
    }
  }

  observeScroll() {
    let ticking = false;
    
    const checkPosition = () => {
      const rect = this.originalCartButton.getBoundingClientRect();
      const isBelow = rect.bottom < 0;
      
      if (isBelow) {
        this.stickyCart.classList.add('is-visible');
      } else {
        this.stickyCart.classList.remove('is-visible');
      }
      
      ticking = false;
    };
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(checkPosition);
        ticking = true;
      }
    });
    
    // 初期チェック
    checkPosition();
  }

  selectInitialVariantInDrawer() {
    // URLにバリアントパラメータがある場合は何もしない
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('variant')) return;
    
    // ドロワー内のvariant-selectsを取得
    const drawerVariantSelects = this.drawer.querySelector('variant-selects');
    if (!drawerVariantSelects) return;
    
    // data-selected-variantからバリアント情報を取得
    const variantDataElement = drawerVariantSelects.querySelector('[data-selected-variant]');
    if (!variantDataElement) return;
    
    try {
      const variant = JSON.parse(variantDataElement.textContent);
      if (!variant || !variant.options) return;
      
      // 各オプションのラジオボタンを選択
      const fieldsets = drawerVariantSelects.querySelectorAll('fieldset');
      variant.options.forEach((optionValue, index) => {
        if (!fieldsets[index]) return;
        
        const radios = fieldsets[index].querySelectorAll('input[type="radio"]');
        
        // 該当するラジオボタンを探して選択
        radios.forEach(radio => {
          if (radio.value === optionValue && !radio.checked) {
            radio.checked = true;
          }
        });
      });
    } catch (e) {
      console.error('Drawer variant selection error:', e);
    }
  }

  openDrawer() {
    const overlay = this.drawer.querySelector('[data-drawer-overlay]');
    
    this.drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    // オーバーレイにis-visibleクラスを追加
    if (overlay) {
      setTimeout(() => {
        overlay.classList.add('is-visible');
      }, 10);
    }
    
    // ドロワーを開くたびにバリアント選択状態を確認
    this.selectInitialVariantInDrawer();
  }

  closeDrawer() {
    const overlay = this.drawer.querySelector('[data-drawer-overlay]');
    
    // オーバーレイのis-visibleクラスを削除
    if (overlay) {
      overlay.classList.remove('is-visible');
    }
    
    // トランジション後にドロワーを非表示
    setTimeout(() => {
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }, 300);
  }

  addToCart() {
    // ドロワー内の数量とバリアントを元のフォームに同期
    this.syncDrawerToForm();
    
    // 元のフォームのsubmitボタンをクリック
    if (this.originalCartButton) {
      this.originalCartButton.click();
    }
    
    // ドロワーを閉じる
    this.closeDrawer();
  }
  
  syncDrawerToForm() {
    // ドロワー内の数量入力を取得
    const drawerQuantity = this.drawer.querySelector('.quantity__input');
    
    // 元のフォームの数量入力を取得
    const formQuantity = this.productForm.querySelector('.quantity__input');
    
    // 数量を同期
    if (drawerQuantity && formQuantity) {
      formQuantity.value = drawerQuantity.value;
      
      // 数量変更イベントを発火（他の処理がある場合のため）
      formQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // バリアント選択も同期（ラジオボタンの場合）
    const drawerVariantInputs = this.drawer.querySelectorAll('input[name="id"]');
    const formVariantInput = this.productForm.querySelector('input[name="id"]');
    
    drawerVariantInputs.forEach(input => {
      if (input.checked && formVariantInput) {
        formVariantInput.value = input.value;
        formVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const countElements = document.querySelectorAll('[data-cart-count]');
      countElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
}

// 初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductStickyCart();
  });
} else {
  new ProductStickyCart();
}
